import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, FlaskConical, HeartHandshake } from "lucide-react";

export default function About() {
    return (
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-14" data-testid="about-page">
            <div className="text-center mb-14">
                <p className="eyebrow">Our story</p>
                <h1 className="h-display text-[44px] sm:text-[64px] mt-4">
                    Built for women,<br />reviewed by science.
                </h1>
                <p className="text-[var(--body)] max-w-2xl mx-auto mt-6 text-[16px] leading-relaxed">
                    UCare Essentials began with a simple question: why do women's wellness products so often skip the rigour of clinical evidence? We built a brand that doesn't. Every formula is reviewed by our board of doctors and tested by independent labs before it ever reaches your routine.
                </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6 mb-14">
                {[
                    { icon: <ShieldCheck />, t: "Clinical integrity", d: "Every batch tested for purity, potency, and heavy metals by independent third-party labs." },
                    { icon: <FlaskConical />, t: "Evidence-based botanicals", d: "Inositol, Ashwagandha, Bhringraj, Omega 3 & 6 — chosen because the science is consistent, not because trends say so." },
                    { icon: <HeartHandshake />, t: "Ethical sourcing", d: "Partnerships with certified organic farms across Kerala, Karnataka, and the Himalayas." },
                ].map((s) => (
                    <div key={s.t} className="card p-7">
                        <div className="w-12 h-12 rounded-full bg-[var(--bg-alt)] grid place-items-center text-[var(--taupe)] mb-4">{s.icon}</div>
                        <h3 className="font-serif text-[22px] text-[var(--ink)] mb-2">{s.t}</h3>
                        <p className="text-[13.5px] text-[var(--body)] leading-relaxed">{s.d}</p>
                    </div>
                ))}
            </div>

            <div className="card p-10 lg:p-14 text-center">
                <h2 className="h-display text-[28px] lg:text-[40px] mb-4">A standard, not a trend.</h2>
                <p className="text-[var(--body)] max-w-2xl mx-auto mb-7">
                    No artificial fillers. No marketing claims without evidence. Just careful, considered formulations made for the women we know — including ourselves.
                </p>
                <Link to="/shop" className="btn btn-primary">Explore Our Care</Link>
            </div>
        </div>
    );
}
